const archivedTabs = [
    { id: 'active', name: 'active', value: false },
    { id: 'archive', name: 'archive', value: true },
    { id: 'all', name: 'all', value: null },
];

export default archivedTabs;